/* Storefront theme: core scripts. Each feature only runs when its markup is on the page. */
(function () {
  'use strict';
  var d = document;
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || d).querySelectorAll(sel)); };
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Video modal (fullscreen player) ---------- */
  var modal = d.getElementById('VideoModal');
  var modalBody = modal && modal.querySelector('[data-vmodal-body]');

  function openVideo(srcVideo) {
    if (!modal || !srcVideo) return;
    var v = d.createElement('video');
    v.setAttribute('playsinline', '');
    v.controls = true;
    v.autoplay = true;
    v.loop = true;
    v.setAttribute('controlslist', 'nodownload noplaybackrate');
    v.setAttribute('disablepictureinpicture', '');
    if (srcVideo.poster) v.poster = srcVideo.poster;
    var sources = srcVideo.querySelectorAll('source');
    if (sources.length) {
      sources.forEach(function (s) { v.appendChild(s.cloneNode()); });
    } else if (srcVideo.currentSrc || srcVideo.src) {
      v.src = srcVideo.currentSrc || srcVideo.src;
    }
    modalBody.innerHTML = '';
    modalBody.appendChild(v);
    modal.hidden = false;
    d.documentElement.classList.add('modal-open');
    v.muted = false;
    var p = v.play();
    if (p && p.catch) p.catch(function () { v.muted = true; v.play(); });
    modal.querySelector('[data-vmodal-close]').focus();
  }

  function closeVideo() {
    if (!modal || modal.hidden) return;
    var v = modalBody.querySelector('video');
    if (v) { v.pause(); v.removeAttribute('src'); v.load(); }
    modalBody.innerHTML = '';
    modal.hidden = true;
    d.documentElement.classList.remove('modal-open');
  }

  window.SFVideo = { open: openVideo, close: closeVideo };

  if (modal) {
    modal.addEventListener('click', function (e) {
      if (e.target === modal || e.target.closest('[data-vmodal-close]')) closeVideo();
    });
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeVideo(); });
  }

  d.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-video-open]');
    if (!trigger) return;
    e.preventDefault();
    openVideo(trigger.querySelector('video'));
  });

  /* ---------- Muted previews: play only while visible ---------- */
  function initAutoplay(root) {
    var vids = $$('[data-autoplay] video, video[data-autoplay]', root);
    if (!vids.length) return;
    if (!('IntersectionObserver' in window)) {
      vids.forEach(function (v) { v.play().catch(function () {}); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting) {
          if (v.preload === 'none') v.preload = 'metadata';
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          v.pause();
        }
      });
    }, { rootMargin: '120px 0px', threshold: 0.15 });
    vids.forEach(function (v) { v.muted = true; io.observe(v); });
  }

  /* ---------- Horizontal rows (videos, reviews) prev/next ---------- */
  function initRows(root) {
    $$('[data-row-nav]', root).forEach(function (nav) {
      var row = d.getElementById(nav.getAttribute('data-row-nav'));
      if (!row) return;
      nav.addEventListener('click', function (e) {
        var b = e.target.closest('[data-dir]');
        if (!b) return;
        row.scrollBy({ left: (b.getAttribute('data-dir') === 'next' ? 1 : -1) * row.clientWidth * 0.8, behavior: 'smooth' });
      });
    });
  }

  /* ---------- Banner slider ---------- */
  function initBanners(root) {
    $$('[data-banner]', root).forEach(function (banner) {
      if (banner._init) return;
      banner._init = true;
      var track = banner.querySelector('[data-track]');
      var slides = track ? track.children : [];
      var dots = $$('[data-dot]', banner);
      if (!track || slides.length < 2) return;
      var idx = 0;
      var timer = null;
      var delay = parseInt(banner.getAttribute('data-autoplay'), 10) || 0;

      function go(i) {
        idx = (i + slides.length) % slides.length;
        track.scrollTo({ left: slides[idx].offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
      }
      function setActive() {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        idx = i;
        dots.forEach(function (dot, n) { dot.classList.toggle('is-active', n === i); });
      }
      var t;
      track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(setActive, 60); }, { passive: true });
      dots.forEach(function (dot, n) { dot.addEventListener('click', function () { go(n); restart(); }); });

      function restart() {
        if (!delay || reduceMotion) return;
        clearInterval(timer);
        timer = setInterval(function () { go(idx + 1); }, delay * 1000);
      }
      track.addEventListener('touchstart', function () { clearInterval(timer); }, { passive: true });
      track.addEventListener('touchend', restart, { passive: true });
      restart();
    });
  }

  /* ---------- Header: drawer + dropdowns ---------- */
  d.addEventListener('click', function (e) {
    var closer = e.target.closest('[data-close-details]');
    if (closer) {
      var det = closer.closest('details');
      if (det) det.removeAttribute('open');
    }
    $$('.nav details[open]').forEach(function (det) {
      if (!det.contains(e.target)) det.removeAttribute('open');
    });
  });

  /* ---------- Quantity steppers ---------- */
  d.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]');
    if (!b) return;
    var input = b.parentNode.querySelector('input');
    if (!input) return;
    var min = parseInt(input.min, 10) || 1;
    var val = (parseInt(input.value, 10) || min) + (b.getAttribute('data-qty') === 'plus' ? 1 : -1);
    input.value = Math.max(min, val);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Videos: no download button, no picture-in-picture ---------- */
  function lockVideos(root) {
    $$('video', root).forEach(function (v) {
      v.setAttribute('controlslist', 'nodownload noplaybackrate');
      v.setAttribute('disablepictureinpicture', '');
    });
  }

  /* Scroll reveal, tilt, cursor, confetti and other motion live in fx.js */

  /* ---------- Moving reviews: hold to pause on phones ---------- */
  function initMarquee(root) {
    $$('[data-rv-marquee]', root).forEach(function (m) {
      if (m._mq) return;
      m._mq = true;
      m.addEventListener('touchstart', function () { m.classList.add('is-held'); }, { passive: true });
      m.addEventListener('touchend', function () { m.classList.remove('is-held'); }, { passive: true });
    });
  }

  /* ---------- Hero buttons with no link scroll to the next section ---------- */
  d.addEventListener('click', function (e) {
    var a = e.target.closest('[data-scroll-next]');
    if (!a) return;
    var sec = a.closest('.shopify-section');
    var next = sec && sec.nextElementSibling;
    if (!next) return;
    e.preventDefault();
    next.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
  });

  /* ---------- "Order" buttons in other sections scroll to the order form ---------- */
  d.addEventListener('click', function (e) {
    var a = e.target.closest('[data-scroll-cta]');
    if (!a || a.getAttribute('href') !== '#main') return;
    var cta = d.querySelector('.pp [data-cta]') || d.querySelector('.pp-price');
    if (!cta) return;
    e.preventDefault();
    cta.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
  });

  /* ---------- Instant links: prefetch on hover / touch (browsers without speculation rules) ---------- */
  var supportsSpec = HTMLScriptElement.supports && HTMLScriptElement.supports('speculationrules');
  if (!supportsSpec) {
    var done = {};
    var prefetch = function (e) {
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a || a.origin !== location.origin || a.target === '_blank') return;
      var p = a.pathname;
      if (done[p] || p === location.pathname || /^\/(cart|checkout|account)/.test(p) || a.hash) return;
      done[p] = true;
      var l = d.createElement('link');
      l.rel = 'prefetch';
      l.href = a.href;
      d.head.appendChild(l);
    };
    d.addEventListener('mouseover', prefetch, { passive: true });
    d.addEventListener('touchstart', prefetch, { passive: true });
  }

  function initAll(root) {
    initAutoplay(root);
    initRows(root);
    initBanners(root);
    lockVideos(root);
    initMarquee(root);
  }

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', function () { initAll(d); });
  else initAll(d);

  /* Theme editor: re-init sections when they are added or changed */
  d.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
